export const typesRequiredRegister = [
  "vcard",
  "coupon",
  "event",
  "location",
  "app",
  "images",
  "video",
  "mp3",
  "businesspage",
  "socialmedia",
  "facebook",
];
